
<template>
  <div class="search-results__item card" v-bind:class="{ 'printing-card': printing, 'not-printing-card': !printing }">
    <div class="card__cta">
      <a :href="url" class="card__edit-btn" :class="{ 'visible' : showEdit }">Edit <i class="icon-edit"></i></a>
      <button v-if="printing==undefined || !printing" class="card__expand-btn" v-on:click="expandCard" title="Expand" aria-label="Expand">
        <i class="icon-chevron-down" :class="{ 'expanded' : expanded }"></i>
      </button>
    </div>
    <div class="card__content-wrapper" v-bind:class="{ 'expanded' : expanded }">
      <span class="card__header__item">{{getValueOfHeader('Location:')}}</span>
      <span class="card__header__item">{{getValueOfHeader('Year of election:')}}</span>
      <span class="card__header__item" v-for="field in data" v-bind:key="field.Key" v-if="field.Key ==='Early election:' && field.Value == 1" >Early election</span>
    <span class="card__header__item">{{getValueOfHeader('Type of observation:')}}</span>
      
    <span class="card__header__item"> {{getValueOfHeader('Election type:')}} </span>

    <span class="card__header__item" v-if="getValueOfHeader('Election type 2:') && getValueOfHeader('Election type 2:') !== 'Referendum'">
        and {{getValueOfHeader('Election type 2:')}}
    </span>
      <span class="card__header__item" v-if="getValueOfHeader('Election type:') && getValueOfHeader('Election type:')!= 'Presidential' && getValueOfHeader('Election type:')!= 'Referendum'"> 
        elections
      </span>
      <span class="card__header__item" v-if="getValueOfHeader('Election type:') && getValueOfHeader('Type of election:') == 'Presidential'"> 
        election
      </span>
      <span  class="card__header__item" v-if="getValueOfHeader('Type of election 2:') && getValueOfHeader('Type of election 2:') === 'Referendum'">
        and Referendum
      </span>

      <div class="card__field"
            v-bind:class="{ 'card__field--block' : field.IsBlock }"
            v-for="field in data"
            :key="field.Id"
            v-if="displayField(field.Key)">
          <span class="card__field__type" v-if="field.Key != 'Text of the recommendation:'">{{field.Key}}</span> 
          <span class=" card__field__value" v-html="field.Value"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultCard',
  props: ['data', 'expanded', 'url', 'printing'],
  computed: {
    expand: {
      get() {
        return this.expanded;
      },
      set(value) {
        this.expanded = value;
        this.createEditButtons();
        this.$emit('expanded', value);
      }
    }
  },
  url() {
    return '';
  },
  showEdit() {
    return false;
  },
  created() {
    this.handleDateFormat()
  },
  updated() {
    this.handleDateFormat()
  },
  mounted() {
    this.handleDateFormat()
  },
  methods: {
    expandCard() {
      this.expanded = !this.expanded;
      this.createEditButtons();
    },
    createEditButtons() {
      var url = '/umbraco#/content/content/edit/';
      for (var i = 0; i < this.data.length; i++) {
        var item = this.data[i];
        if (item.Key === 'Id') {
            url += item.Value;
        }

        if (item.Key === 'LoggedIn') {
            this.showEdit = item.Value && this.expanded;
        }
      }

      for (var j = 0; j < this.data.length; j++) {
        var it = this.data[j];
        if (this.showEdit && it.Key === 'Id') {
            it.Key = "Recommendation # in DB:";
        }
      }
      this.url = url;
    },
    getValueOfHeader(key) {
      for (let index = 0; index < this.data.length; index++) {
        const element = this.data[index];
        if(element.Key == key)
          return element.Value;
      }

      return undefined;
    },
    displayField(key) {
        var dontDisplayTheseFields = ['Location:', 'Year of election:', 'Early election:', 'Type of observation:', 'LoggedIn', 'Id', 'Election type:', 'Election type 2:'];
        var result = !(dontDisplayTheseFields.indexOf(key) >= 0);
        return result;
    },
    formatDate(date) {
        var strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        var d = date.getDate();
        var m = strArray[date.getMonth()];
        var y = date.getFullYear();
        return '' + d  + ' ' + m + ' ' + y;
    },
    handleDateFormat() {
      for (var i = 0; i < this.data.length; i++) {
        var item = this.data[i];

        if (item.Value.toString().startsWith("/Date")) {
            var date = new Date(parseInt(item.Value.substr(6)));
            item.Value = this.formatDate(date);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "src/scss/variables";

  .card {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    text-align: left;
    padding: 30px;
    border-width: 2px;
    border-style: solid;   
    border-radius: 5px;
    font-family: $main-font;
	line-height: 1.4em;
    text-decoration: none;
    transition: all 0.2s;
    position: relative;

    &:hover {
      .card__icon {
        display: inline-block;
      }
    }

    &__header {
        display:inline;
    }

    &__content-wrapper {
      max-height: 85px;
      overflow: hidden;
      // transition: all 0.5s;
      &.expanded {
        animation: expand 0.5s forwards;
      };
    }
    &__field {
      display: block;
      width:100%;

      &--inline {
        display: inline-block;
      }
      &__type {
        display: inline;
      }

      &__value {
        display: inline;
      }
    }
    &__icon {
      position: absolute;
      right: 25px;
      top: 25px;
      display: none;
    }
    &__cta {
      position: absolute;
      right: 15px;
      bottom: 15px;
      display: flex;
      align-items: center;
    }
    &__edit-btn {
      border: 2px solid;
      border-radius: 5px;
      margin-right: 10px;
      height: 30px;
      padding: 0 20px;
      align-items: center;
      display: none;
      transition: all 0.2s;
      text-decoration: none;
      outline: none;
      
      i {
        margin-left: 10px;
      }
      &.visible {
        display: flex;
      }
    }

    &__expand-btn {
      height: 30px;
      width: 30px;     
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      transition: transform 0.2s;
      border: 2px solid;     
      border-radius: 5px;      
      transition: all 0.2s;
      outline: none;
      padding: 0;

      i.expanded {
        transform: rotate(180deg);
      }
    }
    @media (max-width: 991px) {
      padding: 20px;
    }
  }

  @keyframes expand {
    0% { max-height: 65px; }
    50% { overflow: visible; }
    100% { max-height: 2000px; }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/ResultCard.vue